import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterBar = ({ filters, onFilterChange }) => {
  const sortOptions = [
    { value: 'growth', label: 'Growth Rate', icon: 'TrendingUp' },
    { value: 'followers', label: 'Followers', icon: 'Users' },
    { value: 'engagement', label: 'Engagement', icon: 'Zap' },
    { value: 'quality', label: 'Quality Score', icon: 'Star' }
  ];

  const timeframeOptions = [
    { value: 'day', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'all', label: 'All Time' }
  ];

  const specializationOptions = [
    { value: 'all', label: 'All Specializations' },
    { value: 'Dramatic', label: 'Dramatic' },
    { value: 'Comedy', label: 'Comedy' },
    { value: 'Classical', label: 'Classical' },
    { value: 'Contemporary', label: 'Contemporary' },
    { value: 'Character', label: 'Character' }
  ];

  return (
    <div className="modern-card">
      <div className="flex flex-col sm:flex-row gap-4">
        {/* Sort By */}
        <div className="flex-1">
          <label className="block text-sm font-medium text-muted-foreground mb-2">
            Sort By
          </label>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {sortOptions?.map((option) => (
              <button
                key={option?.value}
                onClick={() => onFilterChange?.({ sortBy: option?.value })}
                className={`flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  filters?.sortBy === option?.value
                    ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white' :'bg-background border border-border text-muted-foreground hover:border-purple-500 hover:text-card-foreground'
                }`}
              >
                <Icon name={option?.icon} size={16} />
                <span className="hidden sm:inline">{option?.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Timeframe */}
        <div className="sm:w-48">
          <label className="block text-sm font-medium text-muted-foreground mb-2">
            Timeframe
          </label>
          <select
            value={filters?.timeframe}
            onChange={(e) => onFilterChange?.({ timeframe: e?.target?.value })}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-card-foreground focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            {timeframeOptions?.map((option) => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Specialization */}
        <div className="sm:w-56">
          <label className="block text-sm font-medium text-muted-foreground mb-2">
            Specialization
          </label>
          <select
            value={filters?.specialization}
            onChange={(e) => onFilterChange?.({ specialization: e?.target?.value })}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-card-foreground focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            {specializationOptions?.map((option) => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;